import React from 'react';
import ExerciseResults from '../shared/ExerciseResults';
import DiaryNoteSection from '../diary/DiaryNoteSection';

const VocabularyFillInResults = ({ exercises, userResponses, restart, onBack, topic }) => {
  // Calculate statistics
  const correctCount = Object.values(userResponses).filter(response => response.correct).length;
  const totalExercises = exercises.length;

  // Get incorrect exercises
  const incorrectExercises = exercises.filter(
    (exercise, index) => userResponses[index] && !userResponses[index].correct
  );

  // Get correct exercises
  const correctExercises = exercises.filter(
    (exercise, index) => userResponses[index] && userResponses[index].correct
  );

  return (
    <ExerciseResults
      title="Výsledky - Slovicka"
      score={correctCount}
      total={totalExercises}
      color="amber"
      onRestart={restart}
      onBack={onBack}
      diarySection={(
        <DiaryNoteSection
          topic={topic}
          exerciseType="vocabulary_fillin"
        />
      )}
    >
      {/* Incorrect exercises */}
      {incorrectExercises.length > 0 && (
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Cvičení k opravě
          </h3>

          <div className="flex flex-col gap-3">
            {incorrectExercises.map((exercise, idx) => {
              const originalIndex = exercises.indexOf(exercise);
              return (
                <div
                  key={idx}
                  className="p-4 bg-red-50 rounded-lg"
                >
                  <div className="flex items-start gap-3">
                    <span className="text-amber-600 font-semibold min-w-[30px]">
                      #{originalIndex + 1}
                    </span>
                    <div className="flex-1">
                      <div className="text-gray-700 mb-2">
                        <strong className="text-red-500 line-through">
                          {userResponses[originalIndex]?.answer}
                        </strong>
                        {' → '}
                        <strong className="text-green-600">
                          {exercise.correct_answer}
                        </strong>
                      </div>
                      <div className="text-sm font-medium text-red-500">
                        ✗ Spatne
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Correct exercises */}
      {correctExercises.length > 0 && (
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Správně zodpovězená cvičení
          </h3>

          <div className="flex flex-wrap gap-2 justify-center">
            {correctExercises.map((exercise, idx) => (
              <div
                key={idx}
                className="px-4 py-2 bg-green-100 rounded-full text-green-700 font-semibold border border-green-400"
              >
                {exercise.correct_answer}
              </div>
            ))}
          </div>
        </div>
      )}
    </ExerciseResults>
  );
};

export default VocabularyFillInResults;
